import addComponent from "./addComponent";
import addModule from "./addModule";
import addTemplate from "./addTemplate";
import addObject from "./addObject";
import addElement from "./addElement";

export default function processElement(type: string, options: any) {
	let output: any;

	switch (type) {
		case "component":
			output = addComponent(options);
			break;
		case "module":
			output = addModule(options);
			break;
		case "template":
			output = addTemplate(options);
			break;
		case "object":
			output = addObject(options);
			break;
		case "element":
			output = addElement(options);
			break;
		default:
			return;
	}

	return output;
}
